import "./EmptyState.css";

/*
  EmptyState Component

  One pattern for "nothing here", "could not load" and "loading" blocks.

  variant:
  empty   = nothing to show yet (role: none)
  error   = something failed (role="alert")
  loading = busy (role="status")

  icon     optional lucide icon element
  title    optional bold line
  children message
  action   optional button(s), e.g. Retry
  compact  less padding, for use inside cards and lists
*/

const EmptyState = ({ variant = "empty", icon, title, children, action, compact = false, className = "" }) => (
  <div
    className={`ui-empty-state ${variant} ${compact ? "compact" : ""} ${className}`}
    role={variant === "error" ? "alert" : variant === "loading" ? "status" : undefined}
  >
    {icon && <span className="ui-empty-icon" aria-hidden="true">{icon}</span>}
    {title && <strong className="ui-empty-title">{title}</strong>}
    {children && <p className="ui-empty-text">{children}</p>}
    {action && <div className="ui-empty-action">{action}</div>}
  </div>
);

export default EmptyState;
